import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { mergeMap, of, switchMap } from 'rxjs';
import { map, catchError, withLatestFrom, tap, filter } from 'rxjs/operators';
import * as i2 from '@angular/common/http';
import * as i4 from '@rogers/self-serve-common/user-permission';
import { UserPermissionModule } from '@rogers/self-serve-common/user-permission';
import { COMMON_APP_CONFIG } from '@rogers/self-serve-common';
import { createEntityAdapter } from '@ngrx/entity';
import { cloneDeep } from 'lodash';
import * as i1$1 from '@ngrx/store';
import { createFeatureSelector, createSelector, StoreModule, select } from '@ngrx/store';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2$2 from '@rogers/cdk/button';
import { ButtonComponent } from '@rogers/cdk/button';
import * as i1$2 from '@rogers/cdk/modal';
import { ModalModule } from '@rogers/cdk/modal';
import * as i10 from '@rogers/self-serve-utils/format-phone';
import { FormatPhoneModule } from '@rogers/self-serve-utils/format-phone';
import * as i2$1 from '@rogers/cdk/common/classes';
import * as i4$2 from '@rogers/cdk/tile';
import { TileComponent } from '@rogers/cdk/tile';
import * as i6 from '@rogers/self-serve-utils';
import { CustomTranslationModule } from '@rogers/self-serve-utils';
import * as i5 from '@rogers/cdk/form';
import { FormModule } from '@rogers/cdk/form';
import * as i6$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3$1 from '@rogers/cdk/link';
import { LinkComponent } from '@rogers/cdk/link';
import * as i1$3 from '@rogers/cdk/price';
import { PriceComponent } from '@rogers/cdk/price';
import * as i2$3 from '@rogers/self-serve-common/content';
import { ContentComponent } from '@rogers/self-serve-common/content';
const _c0 = a0 => ({
  bpoName: a0
});
const _c1 = (a0, a1, a2) => ({
  discount: a0,
  month: a1,
  dynamicDiscount: a2
});
const _c2 = a0 => ({
  dynamicData: a0
});
function BpoOfferComponent_ng_container_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
    i0.ɵɵpipe(1, "ssTranslate");
    i0.ɵɵpipe(2, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 4, ctx_r1.getTranslationKey("msf_discount"), i0.ɵɵpureFunction3(7, _c1, ctx_r1.bpoDetails.discountValue, ctx_r1.bpoDetails.duration, i0.ɵɵpipeBind2(1, 1, ctx_r1.bpoDetails.displayName, ctx_r1.language))), i0.ɵɵsanitizeHtml);
  }
}
function BpoOfferComponent_ng_container_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ss-has-user-permission", 6);
    i0.ɵɵelementContainerStart(1, 9);
    i0.ɵɵelement(2, "span", 5);
    i0.ɵɵpipe(3, "ssTranslate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(5, 10);
    i0.ɵɵelement(6, "span", 5);
    i0.ɵɵpipe(7, "ssTranslate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("switchID", ctx_r1.switchID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 6, ctx_r1.getTranslationKey("data_bonus"), i0.ɵɵpureFunction1(15, _c2, i0.ɵɵpipeBind2(3, 3, ctx_r1.bpoDetails.displayName, ctx_r1.language))), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(8, 12, ctx_r1.getTranslationKey("data_bonus"), i0.ɵɵpureFunction1(17, _c2, i0.ɵɵpipeBind2(7, 9, ctx_r1.bpoDetails.featureValue, ctx_r1.language))), i0.ɵɵsanitizeHtml);
  }
}
function BpoOfferComponent_ng_container_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 5);
    i0.ɵɵpipe(1, "ssTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.bpoDetails.featureValue, ctx_r1.language), i0.ɵɵsanitizeHtml);
  }
}
function BpoOfferComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ds-tile", 1)(2, "div", 2);
    i0.ɵɵelement(3, "p", 3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, BpoOfferComponent_ng_container_0_Conditional_6_Template, 3, 11, "span", 5)(7, BpoOfferComponent_ng_container_0_Conditional_7_Template, 9, 19, "ss-has-user-permission", 6)(8, BpoOfferComponent_ng_container_0_Conditional_8_Template, 2, 4, "span", 5);
    i0.ɵɵelementStart(9, "div", 7)(10, "button", 8);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵlistener("click", function BpoOfferComponent_ng_container_0_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.redeemBpoOffer());
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 6, ctx_r1.getNoTransactionBpoBonusHeadingText(ctx_r1.bpoDetails.bpoType)), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(6, ctx_r1.bpoDetails.bpoType === "MSF_DISCOUNT_BPO" ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(7, ctx_r1.bpoDetails.bpoType === "DATA_BONUS_BPO" ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(8, ctx_r1.bpoDetails.bpoType === "LD_BPO" ? 8 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(11, 8, "buyflow.hero-offers.cta.redeem-offer-alt-text"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 10, "buyflow.hero-offers.cta.redeem-offer"), " ");
  }
}
function TvmOfferComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 11);
    i0.ɵɵpipe(5, "ssTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "buyflow.hero-offers.offer-detail.talk"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 4, ctx_r0.offer.talkDisplayName, ctx_r0.language), i0.ɵɵsanitizeHtml);
  }
}
function TvmOfferComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 11);
    i0.ɵɵpipe(5, "ssTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "buyflow.hero-offers.offer-detail.text"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 4, ctx_r0.offer.textDisplayName, ctx_r0.language), i0.ɵɵsanitizeHtml);
  }
}
const _forTrack0 = ($index, $item) => $item.ctn;
const _c3 = a0 => ({
  ctn: a0
});
function OfferDetailModalComponent_Conditional_8_For_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
    i0.ɵɵtext(1, " - ");
  }
  if (rf & 2) {
    const offer_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", offer_r3.subscriberFirstName, i0.ɵɵsanitizeHtml);
  }
}
function OfferDetailModalComponent_Conditional_8_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 6);
    i0.ɵɵtemplate(1, OfferDetailModalComponent_Conditional_8_For_6_Conditional_1_Template, 2, 1);
    i0.ɵɵelement(2, "span", 7);
    i0.ɵɵpipe(3, "formatPhone");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const offer_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngValue", offer_r3)("selected", offer_r3.ctn === ctx_r1.selectedCtn);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, offer_r3.subscriberFirstName ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 4, offer_r3.ctn), i0.ɵɵsanitizeHtml);
  }
}
function OfferDetailModalComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ds-form-field")(1, "ds-input-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "select", 5);
    i0.ɵɵlistener("ngModelChange", function OfferDetailModalComponent_Conditional_8_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeSelectedOffer($event));
    });
    i0.ɵɵrepeaterCreate(5, OfferDetailModalComponent_Conditional_8_For_6_Template, 4, 6, "option", 6, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "buyflow.hero-offers.common.select-phone-number"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r1.offerDetail);
    i0.ɵɵattribute("data-qm-encrypt", true);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.offersList);
  }
}
function OfferDetailModalComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ss-tvm-offer-detail", 8);
    i0.ɵɵlistener("tvmOfferClicked", function OfferDetailModalComponent_Conditional_13_Template_ss_tvm_offer_detail_tvmOfferClicked_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectTvmOffer());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("firstName", ctx_r1.offerDetail.subscriberFirstName)("language", ctx_r1.language)("province", ctx_r1.offerDetail.province)("tvmOffer", ctx_r1.offerDetail.tvmOffer);
  }
}
function OfferDetailModalComponent_Conditional_14_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ds-tile")(1, "div", 10)(2, "div")(3, "p", 11);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "a", 12);
    i0.ɵɵlistener("click", function OfferDetailModalComponent_Conditional_14_Conditional_1_Template_a_click_7_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.seeMorePlanOffers());
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "buyflow.hero-offers.upgrade-plan.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r1.moreOffersUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 5, "buyflow.hero-offers.upgrade-plan.cta"));
  }
}
function OfferDetailModalComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ss-bpo-offer", 9);
    i0.ɵɵlistener("bpoOfferClicked", function OfferDetailModalComponent_Conditional_14_Template_ss_bpo_offer_bpoOfferClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.redeemBpoOffer());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, OfferDetailModalComponent_Conditional_14_Conditional_1_Template, 10, 7, "ds-tile");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("language", ctx_r1.language)("bpoDetails", ctx_r1.offerDetail.noTransactionalBpo);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, !ctx_r1.offerDetail.tvmPresent ? 1 : -1);
  }
}
var TargetedOffersActionTypes = /*#__PURE__*/function (TargetedOffersActionTypes) {
  TargetedOffersActionTypes["GetTargetedOffers"] = "[TargetedOffer] Get Targeted Offers";
  TargetedOffersActionTypes["GetTargetedOffersSuccess"] = "[TargetedOffer] Get TargetedOffers Success";
  TargetedOffersActionTypes["GetTargetedOffersFail"] = "[TargetedOffer] Get TargetedOffers Failed";
  TargetedOffersActionTypes["ClearTargetedOffers"] = "[TargetedOffer] Clear TargetedOffers";
  TargetedOffersActionTypes["AddEmptyTargetedOffers"] = "[TargetedOffer] Add empty TargetedOffers";
  TargetedOffersActionTypes["ClearStandAloneOffer"] = "[TargetedOffer] Clear StandAloneOffer";
  return TargetedOffersActionTypes;
}(TargetedOffersActionTypes || {});
class GetTargetedOffers {
  constructor(payload) {
    this.payload = payload;
    this.type = TargetedOffersActionTypes.GetTargetedOffers;
  }
}
class GetTargetedOffersSuccess {
  constructor(payload) {
    this.payload = payload;
    this.type = TargetedOffersActionTypes.GetTargetedOffersSuccess;
  }
}
class ClearStandAloneOffer {
  constructor(payload) {
    this.payload = payload;
    this.type = TargetedOffersActionTypes.ClearStandAloneOffer;
  }
}
class GetTargetedOffersFail {
  constructor(payload) {
    this.payload = payload;
    this.type = TargetedOffersActionTypes.GetTargetedOffersFail;
  }
}
class ClearTargetedOffers {
  constructor() {
    this.type = TargetedOffersActionTypes.ClearTargetedOffers;
  }
}
class AddEmptyTargetedOffers {
  constructor(payload) {
    this.payload = payload;
    this.type = TargetedOffersActionTypes.AddEmptyTargetedOffers;
  }
}
let TargetedOffersConfigService = /*#__PURE__*/(() => {
  class TargetedOffersConfigService {
    /** @nocollapse */static {
      this.ɵfac = function TargetedOffersConfigService_Factory(t) {
        return new (t || TargetedOffersConfigService)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TargetedOffersConfigService,
        factory: TargetedOffersConfigService.ɵfac
      });
    }
  }
  return TargetedOffersConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var BpoType = /*#__PURE__*/function (BpoType) {
  BpoType["DATA_BONUS_BPO"] = "DATA_BONUS_BPO";
  BpoType["LD_BPO"] = "LD_BPO";
  BpoType["MSF_DISCOUNT_BPO"] = "MSF_DISCOUNT_BPO";
  return BpoType;
}(BpoType || {});
var OfferType = /*#__PURE__*/function (OfferType) {
  OfferType["NO_TRANSACTIONAL_BPO"] = "noTransactionalBpo";
  OfferType["TVM_OFFER"] = "tvmOffer";
  return OfferType;
}(OfferType || {});
let TargetedOffersEffects = /*#__PURE__*/(() => {
  class TargetedOffersEffects {
    constructor(commonAppConfig, actions$, http, config, userPermissionsConfigService) {
      this.commonAppConfig = commonAppConfig;
      this.actions$ = actions$;
      this.http = http;
      this.config = config;
      this.userPermissionsConfigService = userPermissionsConfigService;
      this.loadTargetedOffers$ = createEffect(() => this.actions$.pipe(ofType(TargetedOffersActionTypes.GetTargetedOffers), mergeMap(({
        payload
      }) => {
        return this.getTargetedOffers$(payload.accountNumber, payload.ctnList, payload.accountAlias).pipe(map(targetedOffers => {
          return new GetTargetedOffersSuccess({
            accountNumber: payload.accountNumber,
            offers: targetedOffers
          });
        }), catchError(error => of(new GetTargetedOffersFail({
          accountNumber: payload.accountNumber,
          error
        }))));
      })));
    }
    getTargetedOffersUsingTotes$(ban, ctnList) {
      const url = `${this.config.api.buyflowApiBaseUrl}v1/getTargetedHeroOffers`;
      const payload = {
        ban,
        ctnList,
        applicationId: this.config.applicationId
      };
      return this.http.post(url, payload).pipe(map(response => this.transformTargetedHeroOffers(response)));
    }
    transformTargetedHeroOffers(response) {
      const targetedOfferMap = {};
      Object.keys(response.targetedHeroOfferMap).forEach(ctn => {
        const heroOffer = response.targetedHeroOfferMap[ctn];
        targetedOfferMap[ctn] = {
          ctn,
          standAloneBPO: heroOffer.standAloneBPO ? {
            bpoType: heroOffer.standAloneBPO.bpoType.displayName,
            bpoTypeForAnalytics: heroOffer.standAloneBPO.bpoTypeForAnalytics,
            discountValue: heroOffer.standAloneBPO.discountValue,
            displayName: {
              en: heroOffer.standAloneBPO.displayName,
              fr: heroOffer.standAloneBPO.displayNameFr
            },
            duration: heroOffer.standAloneBPO.duration,
            externalId: heroOffer.standAloneBPO.externalId,
            feature: this.transformFeature(heroOffer.standAloneBPO.featuresMap, heroOffer.standAloneBPO.bpoType.displayName),
            id: heroOffer.standAloneBPO.id
          } : null,
          tvmOffer: heroOffer.tvmOffer ? {
            displayName: {
              en: heroOffer.tvmOffer.displayName,
              fr: heroOffer.tvmOffer.displayNameFr
            },
            externalId: heroOffer.tvmOffer.externalId,
            featuresMap: this.transformFeaturesMap(heroOffer.tvmOffer.featuresMap),
            id: heroOffer.tvmOffer.id,
            price: heroOffer.tvmOffer.price
          } : null
        };
      });
      return Object.values(targetedOfferMap);
    }
    transformFeature(featuresMap, bpoType) {
      if (!featuresMap) {
        return null;
      }
      let feature;
      if (bpoType === 'LD_BPO') {
        feature = featuresMap['LDMINUTES'];
      } else if (bpoType === 'DATA_BONUS_BPO') {
        feature = featuresMap['DATAUSAGE'];
      }
      return feature ? {
        displayName: {
          en: feature.displayNameEN,
          fr: feature.displayNameFR
        },
        unit: {
          en: feature.unitEN,
          fr: feature.unitFR
        }
      } : null;
    }
    transformFeaturesMap(featuresMapResponse) {
      const featuresMap = {};
      Object.keys(featuresMapResponse).forEach(key => {
        const featureResponse = featuresMapResponse[key];
        featuresMap[key] = {
          displayName: {
            en: featureResponse.displayNameEN,
            fr: featureResponse.displayNameFR
          },
          unit: {
            en: featureResponse.unitEN,
            fr: featureResponse.unitFR
          }
        };
      });
      return featuresMap;
    }
    getTargetedOffers$(ban, ctnList, accountAlias) {
      return this.userPermissionsConfigService.hasUserPermission$(this.config.brtSwitchId).pipe(switchMap(hasPermission => {
        return hasPermission ? this.getTargetedOffersUsingMicroservice$(accountAlias) : this.getTargetedOffersUsingTotes$(ban, ctnList);
      }));
    }
    getTargetedOffersUsingMicroservice$(accountAlias) {
      const url = `${this.config.baseApiUrl}${accountAlias}/offers`;
      return this.http.get(url, {
        headers: this.commonAppConfig.getHeaders()
      }).pipe(map(this.transformOffers.bind(this)));
    }
    transformOffers(response) {
      if (!response?.content?.offers) {
        return [];
      }
      const targetedOffers = new Map();
      response.content.offers.forEach(offer => {
        const targetedOffer = targetedOffers.get(offer.subNumber) || {
          ctn: offer.subNumber,
          tvmOffer: null,
          standAloneBPO: null
        };
        if (offer.type === 'TVM') {
          targetedOffer.tvmOffer = {
            displayName: offer.displayName,
            externalId: offer.externalId,
            featuresMap: offer.features.reduce((acc, feature) => {
              acc[feature.type] = {
                displayName: feature.displayName,
                unit: feature.unit
              };
              return acc;
            }, {}),
            id: offer.id,
            price: offer.price
          };
        } else if (offer.type === 'BPO' && offer.bpoType && Object.values(BpoType).includes(offer.bpoType)) {
          targetedOffer.standAloneBPO = {
            bpoType: offer.bpoType,
            bpoTypeForAnalytics: offer.bpoTypeForAnalytics,
            discountValue: parseFloat(offer.discountValue),
            displayName: offer.displayName,
            duration: parseInt(offer.duration),
            externalId: offer.externalId,
            feature: this.getFeatureMap(offer.bpoType, offer.features),
            id: offer.id
          };
        }
        if (targetedOffer.standAloneBPO || targetedOffer.tvmOffer) {
          targetedOffers.set(offer.subNumber, targetedOffer);
        }
      });
      return Array.from(targetedOffers, ([_name, value]) => value);
    }
    getFeatureMap(bpoType, features) {
      if (features?.length && (bpoType === BpoType.LD_BPO || bpoType === BpoType.DATA_BONUS_BPO)) {
        const feature = features[0];
        return {
          displayName: feature.displayName,
          unit: feature.unit
        };
      }
      return null;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TargetedOffersEffects_Factory(t) {
        return new (t || TargetedOffersEffects)(i0.ɵɵinject(COMMON_APP_CONFIG), i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(TargetedOffersConfigService), i0.ɵɵinject(i4.UserPermissionFacadeService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TargetedOffersEffects,
        factory: TargetedOffersEffects.ɵfac
      });
    }
  }
  return TargetedOffersEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const targetedOffersStateName = 'targetedOffers';
const defaultTargetOffersEntity = {
  offers: [],
  loading: false,
  loaded: false,
  accountNumber: null,
  error: null
};
const adapter = createEntityAdapter({
  selectId: targetOffers => targetOffers.accountNumber
});
const initialState = adapter.getInitialState({
  // additional entity state properties
});
function targetedOffersReducer(state = initialState, action) {
  switch (action.type) {
    case TargetedOffersActionTypes.GetTargetedOffers:
      return adapter.addOne({
        ...defaultTargetOffersEntity,
        accountNumber: action.payload.accountNumber,
        loading: true
      }, state);
    case TargetedOffersActionTypes.GetTargetedOffersSuccess:
      return adapter.upsertOne({
        offers: action.payload.offers,
        loading: false,
        loaded: true,
        accountNumber: action.payload.accountNumber,
        error: null
      }, state);
    case TargetedOffersActionTypes.ClearStandAloneOffer:
      let targetedOffers = cloneDeep(state.entities[action.payload.accountNumber].offers);
      const targetedOffer = targetedOffers.find(offer => offer.ctn === action.payload.subscriberNumber);
      targetedOffer.standAloneBPO = null;
      if (!targetedOffer.tvmOffer) {
        targetedOffers = targetedOffers.filter(offer => offer.ctn !== action.payload.subscriberNumber);
      }
      return adapter.upsertOne({
        offers: targetedOffers,
        loading: false,
        loaded: true,
        accountNumber: action.payload.accountNumber,
        error: null
      }, state);
    case TargetedOffersActionTypes.AddEmptyTargetedOffers:
      return adapter.upsertOne({
        offers: [],
        loading: false,
        loaded: true,
        accountNumber: action.payload.accountNumber,
        error: null
      }, state);
    case TargetedOffersActionTypes.GetTargetedOffersFail:
      return adapter.upsertOne({
        offers: [],
        loading: false,
        loaded: false,
        accountNumber: action.payload.accountNumber,
        error: action.payload.error
      }, state);
    case TargetedOffersActionTypes.ClearTargetedOffers:
      return adapter.removeAll(state);
    default:
      return state;
  }
}
const {
  selectEntities
} = adapter.getSelectors();
const selectTargetedOffersEntityState = createFeatureSelector('targetedOffers');
const targetedOffersEntities = createSelector(selectTargetedOffersEntityState, selectEntities);
const getTargetedOffers = createSelector(targetedOffersEntities, entities => accountNumber => entities[accountNumber]);
let TargetedOffersStoreModule = /*#__PURE__*/(() => {
  class TargetedOffersStoreModule {
    /** @nocollapse */static {
      this.ɵfac = function TargetedOffersStoreModule_Factory(t) {
        return new (t || TargetedOffersStoreModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TargetedOffersStoreModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [StoreModule.forFeature(targetedOffersStateName, targetedOffersReducer), EffectsModule.forFeature([TargetedOffersEffects])]
      });
    }
  }
  return TargetedOffersStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BpoOfferSuccessModalComponent = /*#__PURE__*/(() => {
  class BpoOfferSuccessModalComponent {
    constructor(modalRef, modalData) {
      this.modalRef = modalRef;
      this.successData = modalData.source;
    }
    closeModal() {
      this.modalRef.close();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function BpoOfferSuccessModalComponent_Factory(t) {
        return new (t || BpoOfferSuccessModalComponent)(i0.ɵɵdirectiveInject(i1$2.ModalRef), i0.ɵɵdirectiveInject(i2$1.ModalInjectableData));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BpoOfferSuccessModalComponent,
        selectors: [["ss-bpo-offer-success-modal"]],
        decls: 10,
        vars: 16,
        consts: [[3, "heading", "variant", "closeCaption"], ["body", ""], [3, "innerHTML"], ["footer", ""], ["ds-button", "", 3, "click"], [3, "translate"]],
        template: function BpoOfferSuccessModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-modal", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵelement(4, "p", 2);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 3)(7, "button", 4);
            i0.ɵɵlistener("click", function BpoOfferSuccessModalComponent_Template_button_click_7_listener() {
              return ctx.closeModal();
            });
            i0.ɵɵelement(8, "span", 5);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("closeCaption", i0.ɵɵpipeBind1(1, 5, "common.close"));
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(2, 7, ctx.successData.heading))("variant", "success");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 9, ctx.successData.content, i0.ɵɵpureFunction1(14, _c0, ctx.successData.bpoName)), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("translate", i0.ɵɵpipeBind1(9, 12, "common.close"));
          }
        },
        dependencies: [i2$2.ButtonComponent, i1$2.ModalComponent, i4$1.TranslateDirective, i4$1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return BpoOfferSuccessModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const bpoTypeKeyMap = {
  MSF_DISCOUNT_BPO: 'msf_discount',
  DATA_BONUS_BPO: 'data_bonus',
  LD_BPO: 'minutes_bonus'
};
let BpoOfferComponent = /*#__PURE__*/(() => {
  class BpoOfferComponent {
    constructor(config) {
      this.config = config;
      this.language = 'en';
      this.bpoOfferClicked = new EventEmitter();
    }
    get switchID() {
      return this.config.brtSwitchId;
    }
    getNoTransactionBpoBonusHeadingText(bpoType) {
      return `buyflow.hero-offers.bpo-only-heading.${bpoTypeKeyMap[bpoType] || 'bonus'}`;
    }
    redeemBpoOffer() {
      this.bpoOfferClicked.emit();
    }
    getTranslationKey(key) {
      return `buyflow.hero-offers.bpo.detail.${key}`;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function BpoOfferComponent_Factory(t) {
        return new (t || BpoOfferComponent)(i0.ɵɵdirectiveInject(TargetedOffersConfigService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BpoOfferComponent,
        selectors: [["ss-bpo-offer"]],
        inputs: {
          language: "language",
          bpoDetails: "bpoDetails"
        },
        outputs: {
          bpoOfferClicked: "bpoOfferClicked"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [1, "d-flex", "flex-column"], [1, "ds-bgcolor-misty", "p-16", "px-sm-24"], [1, "text-title-4", "text-bold", "mb-0", 3, "innerHTML"], [1, "bpo-offer-detail", "p-sm-24"], [3, "innerHTML"], [3, "switchID"], [1, "pt-24", "d-flex", "flex-column", "flex-sm-row"], ["ds-button", "", 3, "click", "title"], ["hasUserPermission", ""], ["noUserPermission", ""]],
        template: function BpoOfferComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BpoOfferComponent_ng_container_0_Template, 14, 12, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.bpoDetails);
          }
        },
        dependencies: [i2$2.ButtonComponent, i3.NgIf, i4$2.TileComponent, i4.HasUserPermissionComponent, i6.CustomTranslatePipe, i4$1.TranslatePipe],
        styles: [".bpo-offer-detail[_ngcontent-%COMP%]{padding:16px;background-color:#fff;border-top-left-radius:0}.bpo-offer-detail[_ngcontent-%COMP%]   .bpo-header[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{padding-right:8px;margin:0 0 8px;font-size:18px;font-weight:900;line-height:1;color:#000}.bpo-offer-detail[_ngcontent-%COMP%]   .bonus-heading[_ngcontent-%COMP%]{padding-left:8px;font-size:18px;font-weight:900;line-height:36px;color:#000;text-align:right}"]
      });
    }
  }
  return BpoOfferComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TvmOfferComponent = /*#__PURE__*/(() => {
  class TvmOfferComponent {
    constructor() {
      this.language = 'en';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TvmOfferComponent_Factory(t) {
        return new (t || TvmOfferComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TvmOfferComponent,
        selectors: [["ss-tvm-offer"]],
        inputs: {
          offer: "offer",
          language: "language",
          contentPageName: "contentPageName",
          province: "province"
        },
        decls: 16,
        vars: 24,
        consts: [[1, "d-flex", "flex-column", "mt-8"], [1, "d-flex", "flex-row", "align-items-center", "justify-content-sm-start", "justify-content-center"], [1, "text-center", "ds-border-right", "ds-brcolor-concrete", "pl-24"], [1, "ds-price__amountDollars", "text-black", "text-demi", 3, "innerHTML"], [1, "text-body-lg", "text-bold", "pr-16", 3, "innerHTML"], [1, "pl-16", "text-center"], [3, "price", "frequency", "showCents"], [1, "my-24", "mx-24", "text-semi", 3, "innerHTML"], [1, "p-16", "p-sm-24", "ds-bgcolor-misty", "gap-8"], [3, "containerClass", "key", "language", "page", "province"], [1, "text-semi", "pr-8"], [3, "innerHTML"]],
        template: function TvmOfferComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "span", 3);
            i0.ɵɵpipe(4, "ssTranslate");
            i0.ɵɵelement(5, "span", 4);
            i0.ɵɵpipe(6, "ssTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 5);
            i0.ɵɵelement(8, "ds-price", 6);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(10, "p", 7);
            i0.ɵɵpipe(11, "ssTranslate");
            i0.ɵɵelementStart(12, "div", 8);
            i0.ɵɵtemplate(13, TvmOfferComponent_Conditional_13_Template, 6, 7, "p")(14, TvmOfferComponent_Conditional_14_Template, 6, 7, "p");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "ss-content", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 13, ctx.offer.dataDisplayName, ctx.language), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 16, ctx.offer.dataDisplayUnit, ctx.language), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("price", ctx.offer.planPrice)("frequency", i0.ɵɵpipeBind1(9, 19, "buyflow.hero-offers.offer-detail.mo"))("showCents", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 21, ctx.offer.displayName, ctx.language), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(13, ctx.offer.talkDisplayName ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(14, ctx.offer.textDisplayName ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("containerClass", "mt-16 mx-24")("key", "tvm-offer")("language", ctx.language)("page", ctx.contentPageName)("province", ctx.province);
          }
        },
        dependencies: [i1$3.PriceComponent, i2$3.ContentComponent, i6.CustomTranslatePipe, i4$1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return TvmOfferComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TvmOfferDetailComponent = /*#__PURE__*/(() => {
  class TvmOfferDetailComponent {
    constructor(config) {
      this.config = config;
      this.firstName = '';
      this.language = 'en';
      this.tvmOfferClicked = new EventEmitter();
      this.contentPageName = this.config.contentPageName;
      this.moreOffersUrl = this.config.moreOffersUrl;
      this.viewOfferUrl = this.config.api.viewOfferUrl;
    }
    selectTvmOffer() {
      this.tvmOfferClicked.emit();
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TvmOfferDetailComponent_Factory(t) {
        return new (t || TvmOfferDetailComponent)(i0.ɵɵdirectiveInject(TargetedOffersConfigService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TvmOfferDetailComponent,
        selectors: [["ss-tvm-offer-detail"]],
        inputs: {
          firstName: "firstName",
          tvmOffer: "tvmOffer",
          language: "language",
          hasTvmOfferOnly: "hasTvmOfferOnly",
          province: "province"
        },
        outputs: {
          tvmOfferClicked: "tvmOfferClicked"
        },
        decls: 14,
        vars: 19,
        consts: [[1, "d-flex", "flex-column"], [1, "ds-bgcolor-misty", "p-16", "px-sm-24"], [1, "text-title-4", "text-bold", "mb-0"], [3, "language", "contentPageName", "offer", "province"], [1, "d-flex", "flex-column", "flex-sm-row", "px-16", "px-md-24", "py-24", "gap-16"], ["ds-button", "", 3, "click", "href", "title", "variant"], ["target", "_blank", "ds-link", "", 1, "justify-content-center", 3, "href"]],
        template: function TvmOfferDetailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-tile", 0)(1, "div", 1)(2, "p", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(5, "ss-tvm-offer", 3);
            i0.ɵɵelementStart(6, "div", 4)(7, "a", 5);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵlistener("click", function TvmOfferDetailComponent_Template_a_click_7_listener() {
              return ctx.selectTvmOffer();
            });
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "a", 6);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 11, "buyflow.hero-offers.tvm-offer.title"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("language", ctx.language)("contentPageName", ctx.contentPageName)("offer", ctx.tvmOffer)("province", ctx.province);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("href", ctx.viewOfferUrl, i0.ɵɵsanitizeUrl)("title", i0.ɵɵpipeBind1(8, 13, "buyflow.hero-offers.cta.redeem-offer-alt-text"))("variant", "primary");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 15, "buyflow.hero-offers.cta.redeem-offer"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("href", ctx.moreOffersUrl, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 17, "buyflow.hero-offers.tvm-offer.more-offers"));
          }
        },
        dependencies: [i2$2.ButtonComponent, i3$1.LinkComponent, i4$2.TileComponent, TvmOfferComponent, i4$1.TranslatePipe],
        styles: ["@-ms-viewport{width:device-width}.flex-panel[_ngcontent-%COMP%]{flex:0 1 50%}@media (max-width: 599.98px){.offer-tile-container[_ngcontent-%COMP%]   .offer-tile[_ngcontent-%COMP%]:first-child{margin:0 0 16px}}"]
      });
    }
  }
  return TvmOfferDetailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OfferDetailModalComponent = /*#__PURE__*/(() => {
  class OfferDetailModalComponent {
    constructor(modalData, modalRef, config) {
      this.modalRef = modalRef;
      this.config = config;
      this.offerClick = new EventEmitter();
      const modalDataSource = modalData.source;
      this.selectedCtn = modalDataSource.selectedCtn;
      this.offersList = modalDataSource.offersList;
      this.offerDetail = this.offersList.find(offer => offer.ctn === this.selectedCtn);
      this.language = modalDataSource.language;
      this.moreOffersUrl = this.config.moreOffersUrl;
    }
    changeSelectedOffer(offerDetail) {
      this.offerDetail = offerDetail;
    }
    closeModal() {
      this.modalRef.close();
    }
    hasTvmOfferOnly() {
      return !!this.offerDetail && this.offerDetail.tvmPresent && !this.offerDetail.noTransactionalBpoPresent;
    }
    redeemBpoOffer() {
      this.offerClick.emit({
        selectedOffer: {
          noTransactionBpoSelected: true
        },
        targetedOffer: this.offerDetail
      });
    }
    seeMorePlanOffers() {
      this.offerClick.emit({
        selectedOffer: {
          seeMorePlanOffers: true
        },
        targetedOffer: this.offerDetail
      });
    }
    selectTvmOffer() {
      this.offerClick.emit({
        selectedOffer: {
          tvmSelected: true
        },
        targetedOffer: this.offerDetail
      });
    }
    /** @nocollapse */
    static {
      this.ɵfac = function OfferDetailModalComponent_Factory(t) {
        return new (t || OfferDetailModalComponent)(i0.ɵɵdirectiveInject(i2$1.ModalInjectableData), i0.ɵɵdirectiveInject(i1$2.ModalRef), i0.ɵɵdirectiveInject(TargetedOffersConfigService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OfferDetailModalComponent,
        selectors: [["ss-bpo-offer-modal"]],
        outputs: {
          offerClick: "offerClick"
        },
        decls: 15,
        vars: 21,
        consts: [["size", "large-adaptive", 3, "closeClick", "heading", "closeCaption"], ["body", ""], [1, "d-flex", "flex-column", "gap-24"], [1, "text-semi"], [3, "firstName", "language", "province", "tvmOffer"], ["dsNativeControl", "", 3, "ngModelChange", "ngModel"], [3, "ngValue", "selected"], [3, "innerHTML"], [3, "tvmOfferClicked", "firstName", "language", "province", "tvmOffer"], [3, "bpoOfferClicked", "language", "bpoDetails"], [1, "p-24"], [1, "text-body", "text-bold"], ["ds-button", "", "variant", "secondary", 1, "w-100", "w-md-auto", 3, "click", "href"]],
        template: function OfferDetailModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-modal", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵlistener("closeClick", function OfferDetailModalComponent_Template_ds_modal_closeClick_0_listener() {
              return ctx.closeModal();
            });
            i0.ɵɵelementStart(3, "div", 1)(4, "div", 2)(5, "p");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, OfferDetailModalComponent_Conditional_8_Template, 7, 5, "ds-form-field");
            i0.ɵɵelementStart(9, "p", 3);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "formatPhone");
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, OfferDetailModalComponent_Conditional_13_Template, 1, 4, "ss-tvm-offer-detail", 4)(14, OfferDetailModalComponent_Conditional_14_Template, 2, 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind1(1, 8, "buyflow.hero-offers.common.header"))("closeCaption", i0.ɵɵpipeBind1(2, 10, "common.cta.close-alt-text"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 12, "buyflow.hero-offers.common.sub-header"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(8, ctx.offersList.length > 1 ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-qm-encrypt", true);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(12, 16, "buyflow.hero-offers.common.see-offer", i0.ɵɵpureFunction1(19, _c3, i0.ɵɵpipeBind1(11, 14, ctx.offerDetail.ctn))), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(13, (ctx.offerDetail == null ? null : ctx.offerDetail.tvmPresent) ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(14, (ctx.offerDetail == null ? null : ctx.offerDetail.noTransactionalBpoPresent) ? 14 : -1);
          }
        },
        dependencies: [i2$2.ButtonComponent, i5.FormFieldComponent, i5.InputFormDirective, i5.InputLabelComponent, i6$1.NgSelectOption, i6$1.ɵNgSelectMultipleOption, i6$1.SelectControlValueAccessor, i6$1.NgControlStatus, i6$1.NgModel, i1$2.ModalComponent, i4$2.TileComponent, BpoOfferComponent, TvmOfferDetailComponent, i10.FormatPhonePipe, i4$1.TranslatePipe],
        styles: [".flex-panel[_ngcontent-%COMP%]{flex:0 1 50%}.cta-item[_ngcontent-%COMP%]{flex:0 1 33.3333333333%}[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return OfferDetailModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TargetedOffersModule = /*#__PURE__*/(() => {
  class TargetedOffersModule {
    /** @nocollapse */static {
      this.ɵfac = function TargetedOffersModule_Factory(t) {
        return new (t || TargetedOffersModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TargetedOffersModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [ButtonComponent, CommonModule, CustomTranslationModule, FormatPhoneModule, FormModule, FormsModule, LinkComponent, ModalModule, PriceComponent, TileComponent, TranslateModule, UserPermissionModule, ContentComponent]
      });
    }
  }
  return TargetedOffersModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TargetedOffersFacadeService = /*#__PURE__*/(() => {
  class TargetedOffersFacadeService {
    constructor(store) {
      this.store = store;
    }
    addEmptyTargetedOffers(accountNumber) {
      this.store.dispatch(new AddEmptyTargetedOffers({
        accountNumber
      }));
    }
    clearStandAloneOffer(accountNumber, subscriberNumber) {
      this.store.dispatch(new ClearStandAloneOffer({
        accountNumber,
        subscriberNumber
      }));
    }
    loadTargetedOffers$(accountDetails) {
      const {
        accountNumber,
        ctnList,
        accountAlias
      } = accountDetails;
      return of(accountNumber).pipe(withLatestFrom(this.getTargetOffersFromStore(accountNumber)), tap(([_, targetedOffersEntity]) => {
        if (!!targetedOffersEntity && (targetedOffersEntity.loaded || targetedOffersEntity.loading)) {
          return;
        }
        this.store.dispatch(new GetTargetedOffers({
          accountNumber,
          ctnList,
          accountAlias
        }));
      }));
    }
    getTargetedOffers$(accountNumber, province) {
      return this.getTargetOffersFromStore(accountNumber).pipe(filter(targetedOffer => !targetedOffer || targetedOffer.loaded || !!targetedOffer.error), map(targetedOffer => {
        if (!targetedOffer || targetedOffer.error) {
          return null;
        }
        return this.processTargetedHeroOffers(targetedOffer.offers, accountNumber, province);
      }));
    }
    processTargetedHeroOffers(targetedOffers, accountNumber, province) {
      return targetedOffers.map(offer => {
        let noTransactionalBpo = null;
        let noTransactionalBpoPresent = false;
        let tvmOffer = null;
        let tvmPresent = false;
        if (offer.standAloneBPO) {
          noTransactionalBpo = this.getBpoDetails(offer.standAloneBPO, OfferType.NO_TRANSACTIONAL_BPO);
          noTransactionalBpoPresent = true;
        }
        if (offer.tvmOffer) {
          tvmOffer = this.getTvmOfferDetails(offer.tvmOffer, OfferType.TVM_OFFER);
          tvmPresent = true;
        }
        return {
          accountNumber,
          ctn: offer.ctn,
          noTransactionalBpo,
          noTransactionalBpoPresent,
          province,
          tvmOffer,
          tvmPresent
        };
      });
    }
    getBpoDetails(standAloneBPO, category) {
      const bpoDetails = {
        bpoId: standAloneBPO.externalId,
        bpoType: standAloneBPO.bpoType,
        bpoTypeForAnalytics: standAloneBPO.bpoTypeForAnalytics,
        category,
        discountValue: standAloneBPO.discountValue,
        displayName: standAloneBPO.displayName,
        duration: standAloneBPO.duration,
        skuId: standAloneBPO.id
      };
      if (bpoDetails.bpoType === BpoType.LD_BPO || bpoDetails.bpoType === BpoType.DATA_BONUS_BPO) {
        bpoDetails.featureValue = standAloneBPO.feature.displayName;
        bpoDetails.unit = standAloneBPO.feature.unit;
      }
      return bpoDetails;
    }
    getTvmOfferDetails(tvmOffer, offerType) {
      return {
        displayName: tvmOffer.displayName,
        externalId: tvmOffer.externalId,
        offerType,
        planPrice: tvmOffer.price,
        skuId: tvmOffer.id,
        ...this.extractFeatureDetails(tvmOffer.featuresMap, 'data'),
        ...this.extractFeatureDetails(tvmOffer.featuresMap, 'talk'),
        ...this.extractFeatureDetails(tvmOffer.featuresMap, 'text')
      };
    }
    extractFeatureDetails(featuresMap, featureKey) {
      const feature = featuresMap[featureKey];
      if (!feature) {
        return {};
      }
      const featureDetails = {
        [`${featureKey}DisplayName`]: feature.displayName
      };
      if (featureKey === 'data') {
        featureDetails[`${featureKey}DisplayUnit`] = feature.unit;
      }
      return featureDetails;
    }
    getTargetOffersFromStore(accountNumber) {
      return this.store.pipe(select(getTargetedOffers), map(f => f(accountNumber)));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function TargetedOffersFacadeService_Factory(t) {
        return new (t || TargetedOffersFacadeService)(i0.ɵɵinject(i1$1.Store));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TargetedOffersFacadeService,
        factory: TargetedOffersFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TargetedOffersFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AddEmptyTargetedOffers, BpoOfferSuccessModalComponent, BpoType, ClearStandAloneOffer, ClearTargetedOffers, GetTargetedOffers, GetTargetedOffersFail, GetTargetedOffersSuccess, OfferDetailModalComponent, OfferType, TargetedOffersActionTypes, TargetedOffersConfigService, TargetedOffersEffects, TargetedOffersFacadeService, TargetedOffersModule, TargetedOffersStoreModule, adapter, defaultTargetOffersEntity, getTargetedOffers, initialState, selectEntities, targetedOffersReducer, targetedOffersStateName };
